/**
 * Route-level error boundary (#23: "route boundaries").
 *
 * One failing surface must not blank the whole application. The boundary reports the surface name
 * and the real error message. It never claims the action succeeded, and it never retries silently.
 */
import React from 'react';

export default class RouteErrorBoundary extends React.Component {
  constructor(props) {
    super(props);
    this.state = { error: null };
  }

  static getDerivedStateFromError(error) {
    return { error };
  }

  componentDidCatch(error, info) {
    // Kept as a console record on purpose: there is no telemetry sink in this application yet, and
    // inventing one is not this task's scope.
    console.error(`[${this.props.surface}] render failed`, error, info?.componentStack);
  }

  render() {
    const { error } = this.state;
    if (!error) return this.props.children;
    return (
      <main data-route-state="error" style={{ padding: '2rem', maxWidth: '42rem' }}>
        <h1>{this.props.surface} could not be shown</h1>
        <p>{String(error.message ?? error)}</p>
        <p>
          <a href="#/today">Back to Today</a>
        </p>
      </main>
    );
  }
}
